import { render, staticRenderFns } from "./OhGroup.vue?vue&type=template&id=a4ae86e0&"
import script from "./OhGroup.vue?vue&type=script&lang=js&"
export * from "./OhGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports